module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "componend-mdi-icon"
  }, [(_vm.icon) ? [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": _vm.icon
    }
  })]), (_vm.showName) ? _c('div', [_vm._v(_vm._s(_vm.name))]) : _vm._e()] : [_vm._t("default")]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b82aab1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/MdiIcon.vue
// module id = 2312
// module chunks = 1